import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "b-add-edit__form__save" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwButton = _resolveComponent("FwButton")!

  return (_openBlock(), _createBlock(_component_FwButton, {
    color: "transparent",
    fontSize: "12px",
    disabled: _ctx.disabled,
    class: "b-add-edit__form__save-button"
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t('BUTTON.SAVE')), 1)
    ]),
    _: 1
  }, 8, ["disabled"]))
}